import React from 'react'
import { Grid, Input } from '@enterprise-ui/canvas-ui-react'
import '../../Cases/Custom.css'
import { FormikValues } from 'formik'
import {
  VI19_SUB_REASON_CODES,
  VI19_REASON_CODE,
} from '../Services/ConstantData'

interface CreateCurrencyInputProps {
  formik: FormikValues
  state: any
  subReasonCodeText2Label: string
  subReasonCodeText2HelperText: string
}

const CreateCurrencyInput: React.FC<CreateCurrencyInputProps> = ({
  formik,
  state,
  subReasonCodeText2Label,
  subReasonCodeText2HelperText,
}) => (
  <>
    <Grid.Container className="hc-pt-none hc-ml-expanded">
      <Grid.Item xs={10} md={10} className="hc-pt-md">
        <Input.Label
          required={
            formik.values.reasonCode === VI19_REASON_CODE &&
            formik.values.subReasonCode ===
              VI19_SUB_REASON_CODES.AMOUNT_PER_UNIT
          }
        >
          {subReasonCodeText2Label}
        </Input.Label>
        <Input.Currency
          id="subReasonCodeText2"
          onUpdate={(id: any, value: any) => {
            formik.setFieldValue(
              'subReasonCodeText2',
              value ? Number(value) : '',
            )
          }}
          value={formik.values.subReasonCodeText2 || ''}
          allowDecimals
          className="inputtype hc-ta-left"
          disabled={state.showDocuments}
          required={
            formik.values.reasonCode === VI19_REASON_CODE &&
            formik.values.subReasonCode ===
              VI19_SUB_REASON_CODES.AMOUNT_PER_UNIT
          }
        />
      </Grid.Item>
    </Grid.Container>
    <Grid.Container className="hc-pt-none hc-ml-expanded hc-pb-dense">
      <Grid.Item xs={10} md={10} className="hc-pb-md hc-pt-none">
        <Input.Info error={formik.errors.subReasonCodeText2 !== undefined}>
          {subReasonCodeText2HelperText}
        </Input.Info>
      </Grid.Item>
    </Grid.Container>
  </>
)

export default CreateCurrencyInput
